// Global error handler for authentication and other critical errors
export const setupGlobalErrorHandler = () => {
  // Suppress ResizeObserver loop errors as they are harmless but noisy
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed with undelivered notifications')) {
      // Suppress this specific error as it's harmless
      return;
    }
    originalConsoleError.apply(console, args);
  };

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    
    // Check if it's an auth-related error
    if (isAuthError(event.reason)) {
      console.warn('Auth error detected, redirecting to login');
      redirectToLogin();
    }
  });

  // Handle global errors
  window.addEventListener('error', (event) => {
    // Skip ResizeObserver errors
    if (event.message && event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      return;
    }
    
    console.error('Global error:', event.error);
    
    // Check if it's an auth-related error
    if (isAuthError(event.error)) {
      console.warn('Auth error detected, redirecting to login');
      redirectToLogin();
    }
  });
};

// Check if an error is authentication-related
const isAuthError = (error) => {
  if (!error) return false;
  
  const errorMessage = error.message || error.toString() || '';
  const errorCode = error.code || '';
  
  return (
    errorMessage.includes('auth') ||
    errorMessage.includes('permission') ||
    errorMessage.includes('unauthenticated') ||
    errorMessage.includes('unauthorized') ||
    errorMessage.includes('forbidden') ||
    errorCode.startsWith('auth/') ||
    errorCode === 'permission-denied' ||
    errorCode === 'unauthenticated' ||
    errorCode === 'unauthorized'
  );
};

// Redirect to login page
const redirectToLogin = () => {
  // Use window.location for a hard redirect to ensure clean state
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

// Export for use in components
export { isAuthError, redirectToLogin };
